<template>
   <form id="form-element" v-on:submit.prevent="validateBeforeSubmit">
      <div class="form-group">
			<ul class="section-info-disabled">
				<li>Estatus</li>
			</ul>
		</div>
      <div class="form-group">
         <ejs-textbox name="observation" v-model="formData.observation" :multiline="true" floatLabelType="Auto" cssClass="e-outline mb-0" rows="5" placeholder="Observación"></ejs-textbox>
      </div>
      <div class="form-group">
         <label for="uploadFilesSupport">Soporte</label>
         <ejs-uploader ref="uploadObj" name="uploadFiles" id="uploadFilesSupport" :multiple='false' :asyncSettings="uploaderSettings" :uploading="addHeaders" :removing="addHeaders" :success="beforeUploadFiles"></ejs-uploader>
      </div>
      <ejs-button type='submit' cssClass="e-primary">Enviar</ejs-button>
      <ejs-toast ref='toastNotification' title="NOTIFICACIÓN" content="empty" :position="{ X: 'Right', Y: 'Top' }" timeOut=5000></ejs-toast>
   </form>
</template>

<script>
import axios from 'axios'
export default {
   name: "processes-detail-process-task-edit",
   props: ["data"],
      data: function() {
      return {
         formObj: '',
         formData: {
            statusComplianceId: 0,
            affairId: 0,
            observation: '',
            compliance_date: null,
            external_link: null,
            status: 'Pendiente',
            pathFile: ''
         },
         options : {
            rules: {
               'observation': {
                  required: [true, "* Campo observación requerido."]
               }
            }
         },
         uploaderSettings: {
            saveUrl: process.env.BASE_URL_FILE_SAVE,
            removeUrl: process.env.BASE_URL_FILE_REMOVE
         }
      }
   },
   mounted: function () {
      this.formObj = new FormValidator('#form-element', this.options);
   },
	methods: {
      addHeaders: function(args) {
         args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.$store.state.moduleSession.token}`);
      },
      beforeUploadFiles: function(args) {
         var obj = JSON.parse(args.e.srcElement.response);
         this.formData.pathFile = obj.path;
      },
		initProcessTaskEdit: function() {
         this.formData.statusComplianceId = this.data.est_id;
         this.formData.affairId = this.data.asunto_id;
      },
		validateBeforeSubmit: function() {

         let formStatus = this.formObj.validate();
         if (formStatus) {
            axios.post('/auth/processes/setComplianceEdit', {
               data: this.formData,
            }).then(response => {
               //this.formObj.element.reset();
               Vue.prototype.$eventHub.$emit('closeSidebarClick');
               this.$refs.toastNotification.ej2Instances.content = response.data.message;
               this.$refs.toastNotification.show();
            });
         }
      }
	},
	created: function() {
      this.initProcessTaskEdit();
   }
}
</script>